import { SelectProps } from "antd";
import { useAppSelector } from "../../../../../store/reduxHooks";
import { SELECT_BANK_STATUSES } from "../../../../../store/selectors/authSliceLoginSelector";

export const useOptionsBankStatuses = () => {
  const bank_statuses = useAppSelector(SELECT_BANK_STATUSES);

  const selectOptionsBankStatuses: SelectProps["options"] = bank_statuses?.map(
    (item) => {
      return { value: item.id, label: item?.title };
    },
  );

  return selectOptionsBankStatuses;
};
